import type { OrderDetailDTO } from "@/modules/orders/domain/contracts";
import {
  printOrder,
  type PrintType,
} from "@/modules/orders/presentation/utils/print";
import { useOrderPrintContactQuery } from "@/modules/settings/presentation/api/queries";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@devhop/ui";
import { FileText, Package, Printer, Receipt } from "lucide-react";

interface PrintOrderButtonProps {
  order: OrderDetailDTO;
  variant?: "default" | "outline" | "ghost" | "secondary";
  size?: "default" | "sm" | "lg" | "icon";
}

export function PrintOrderButton({
  order,
  variant = "outline",
  size = "default",
}: PrintOrderButtonProps) {
  const { data: printContact } = useOrderPrintContactQuery();
  const contactPhone = printContact?.phone?.trim() ?? "";

  const handlePrint = (type: PrintType) => {
    printOrder(order, type, {
      contactPhone: contactPhone || undefined,
    });
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size}>
          <Printer className="size-4" />
          ພິມ
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => handlePrint("receipt")}>
          <Receipt className="mr-2 size-4" />
          ພິມໃບເກັບເງິນ (Receipt)
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handlePrint("invoice")}>
          <FileText className="mr-2 size-4" />
          ພິມໃບແຈ້ງຫນີ້ (Invoice)
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handlePrint("shipping-label")}>
          <Package className="mr-2 size-4" />
          ພິມປ້າຍຈັດສົ່ງ (Shipping Label)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
